import React from 'react'

function Partners() {
    return (
        <section className='partners' id='partners'>
            <div className="partners-container row center gap-4">
                <div className="partners-title text-white">
                    Powering Startups Like
                </div>
                <div className="partner-image-wrapper row gap-5">
                    {/* <img src="" alt="Agrico Hub" />
                    <img src="" alt="Tesfarm" />
                    <img src="" alt="KAK Solution" /> */}
                    <h3 className='text-white'>Agrico Hub</h3>
                    <h3 className='text-white'>KAK Solution</h3>
                    <h3 className='text-white'>Tesfarm</h3>
                    <h3 className='text-white'>LTECH GH</h3>
                </div>
            </div>
        </section>
    )
}

export default Partners